/* @flow */

import React from 'react';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import SupplierInvoiceDetailsPricesFlexCashSummaryComponent from './cashSummary';
import SupplierInvoiceDetailsPricesFlexValueSummaryComponent from './valueSummary';

import InvoiceBills from 'models/invoices/seller/invoiceBills';
import InvoiceDetails from 'models/invoices/seller/invoiceDetails';

type SupplierInvoiceDetailsPricesFlexComponentProps = {
  invoice: InvoiceDetails;
  invoiceBills: InvoiceBills;
  downloadBill: (billId: number) => void;
}

export default function SupplierInvoiceDetailsPricesFlexComponent(props: SupplierInvoiceDetailsPricesFlexComponentProps) {

  return (
    <Box mt={3} py={3} bgcolor="lightblue.main">
      <Grid container direction="row" justify="space-between" alignItems="flex-start">
        <Grid item xs={12} md={6}>
          <Box px={3}>
            <SupplierInvoiceDetailsPricesFlexValueSummaryComponent
              invoice={props.invoice}
              invoiceBills={props.invoiceBills}
              downloadBill={props.downloadBill}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box px={3}>
            <SupplierInvoiceDetailsPricesFlexCashSummaryComponent invoice={props.invoice} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
